module.exports = __webpack_public_path__ + "static/img/qybj_05.bd5a339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_05.jpg
// module id = Rekn
// module chunks = 0